export interface MarketingImage {
  src: string;
  alt: string;
  locationHint?: string;
}

export const heroImages: MarketingImage[] = [
  {
    src: "https://images.pexels.com/photos/2220316/pexels-photo-2220316.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1280&fit=crop",
    alt: "Indian woman in elegant saree",
    locationHint: "Hero background",
  },
  {
    src: "https://images.pexels.com/photos/3316918/pexels-photo-3316918.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1280&fit=crop",
    alt: "Woman in beautiful Indian attire",
    locationHint: "Hero alternate",
  },
];

export const carouselImages: MarketingImage[] = [
  {
    src: "https://images.pexels.com/photos/2995309/pexels-photo-2995309.jpeg?auto=compress&cs=tinysrgb&w=1200&h=800&fit=crop",
    alt: "Indian woman in traditional kurta",
    locationHint: "Carousel slide 1",
  },
  {
    src: "https://images.pexels.com/photos/2220316/pexels-photo-2220316.jpeg?auto=compress&cs=tinysrgb&w=1200&h=800&fit=crop",
    alt: "Beautiful saree draping",
    locationHint: "Carousel slide 2",
  },
  {
    src: "https://images.pexels.com/photos/3316918/pexels-photo-3316918.jpeg?auto=compress&cs=tinysrgb&w=1200&h=800&fit=crop",
    alt: "Elegant Indian ethnic wear",
    locationHint: "Carousel slide 3",
  },
  {
    src: "https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=1200&h=800&fit=crop",
    alt: "Young woman in stylish outfit",
    locationHint: "Carousel slide 4",
  },
];

export const servicesImages: MarketingImage[] = [
  {
    src: "https://images.pexels.com/photos/3738088/pexels-photo-3738088.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop",
    alt: "Tailor working on sewing machine",
    locationHint: "Alterations service",
  },
  {
    src: "https://images.pexels.com/photos/4620623/pexels-photo-4620623.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop",
    alt: "Custom stitching and tailoring",
    locationHint: "Stitching service",
  },
  {
    src: "https://images.pexels.com/photos/4614227/pexels-photo-4614227.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop",
    alt: "Fabric and measuring tape",
    locationHint: "Express service",
  },
];

export const howItWorksImages: MarketingImage[] = [
  {
    src: "https://images.pexels.com/photos/4050290/pexels-photo-4050290.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&fit=crop",
    alt: "Woman booking appointment on phone",
    locationHint: "Step 1",
  },
  {
    src: "https://images.pexels.com/photos/3738088/pexels-photo-3738088.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&fit=crop",
    alt: "Taking measurements for tailoring",
    locationHint: "Step 2",
  },
  {
    src: "https://images.pexels.com/photos/2995309/pexels-photo-2995309.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&fit=crop",
    alt: "Happy customer with finished outfit",
    locationHint: "Step 3",
  },
];

export const galleryImages: MarketingImage[] = [
  {
    src: "https://images.pexels.com/photos/2220316/pexels-photo-2220316.jpeg?auto=compress&cs=tinysrgb&w=600&h=800&fit=crop",
    alt: "Indian woman in traditional saree",
  },
  {
    src: "https://images.pexels.com/photos/2995309/pexels-photo-2995309.jpeg?auto=compress&cs=tinysrgb&w=600&h=600&fit=crop",
    alt: "Young woman in kurta",
  },
  {
    src: "https://images.pexels.com/photos/3738088/pexels-photo-3738088.jpeg?auto=compress&cs=tinysrgb&w=600&h=900&fit=crop",
    alt: "Tailoring and stitching work",
  },
  {
    src: "https://images.pexels.com/photos/3316918/pexels-photo-3316918.jpeg?auto=compress&cs=tinysrgb&w=600&h=700&fit=crop",
    alt: "Beautiful ethnic outfit",
  },
  {
    src: "https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=600&h=600&fit=crop",
    alt: "Modern Indian fashion",
  },
  {
    src: "https://images.pexels.com/photos/4620623/pexels-photo-4620623.jpeg?auto=compress&cs=tinysrgb&w=600&h=800&fit=crop",
    alt: "Skilled tailoring craftsmanship",
  },
  {
    src: "https://images.pexels.com/photos/4614227/pexels-photo-4614227.jpeg?auto=compress&cs=tinysrgb&w=600&h=700&fit=crop",
    alt: "Fabric selection and measuring",
  },
  {
    src: "https://images.pexels.com/photos/2220316/pexels-photo-2220316.jpeg?auto=compress&cs=tinysrgb&w=600&h=600&fit=crop",
    alt: "Elegant saree styling",
  },
  {
    src: "https://images.pexels.com/photos/2995309/pexels-photo-2995309.jpeg?auto=compress&cs=tinysrgb&w=600&h=900&fit=crop",
    alt: "Traditional kurta design",
  },
  {
    src: "https://images.pexels.com/photos/3738088/pexels-photo-3738088.jpeg?auto=compress&cs=tinysrgb&w=600&h=700&fit=crop",
    alt: "Sewing machine detail",
  },
  {
    src: "https://images.pexels.com/photos/3316918/pexels-photo-3316918.jpeg?auto=compress&cs=tinysrgb&w=600&h=600&fit=crop",
    alt: "Festive Indian wear",
  },
  {
    src: "https://images.pexels.com/photos/1536619/pexels-photo-1536619.jpeg?auto=compress&cs=tinysrgb&w=600&h=800&fit=crop",
    alt: "Contemporary ethnic style",
  },
];

export const testimonialsAvatars: MarketingImage[] = [
  {
    src: "https://images.pexels.com/photos/3764119/pexels-photo-3764119.jpeg?auto=compress&cs=tinysrgb&w=100&h=100&fit=crop",
    alt: "Customer Priya",
  },
  {
    src: "https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=100&h=100&fit=crop",
    alt: "Customer Anjali",
  },
  {
    src: "https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&w=100&h=100&fit=crop",
    alt: "Customer Sneha",
  },
  {
    src: "https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg?auto=compress&cs=tinysrgb&w=100&h=100&fit=crop",
    alt: "Customer Meera",
  },
  {
    src: "https://images.pexels.com/photos/1130626/pexels-photo-1130626.jpeg?auto=compress&cs=tinysrgb&w=100&h=100&fit=crop",
    alt: "Customer Divya",
  },
];

export const beforeAfterImages = {
  before: {
    src: "https://images.pexels.com/photos/4614227/pexels-photo-4614227.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop",
    alt: "Garment before alteration",
  },
  after: {
    src: "https://images.pexels.com/photos/2995309/pexels-photo-2995309.jpeg?auto=compress&cs=tinysrgb&w=800&h=600&fit=crop",
    alt: "Perfectly fitted outfit after tailoring",
  },
};

export const bridalImages: MarketingImage[] = [
  {
    src: "https://images.pexels.com/photos/1456613/pexels-photo-1456613.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop",
    alt: "Indian bridal lehenga",
  },
  {
    src: "https://images.pexels.com/photos/2220316/pexels-photo-2220316.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop",
    alt: "Wedding saree detail",
  },
];
